"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
if (typeof String.prototype.repeat !== 'function') {
    String.prototype.repeat = function (count) {
        'use strict';
        if (this == null)
            throw new TypeError('can\'t convert ' + this + ' to object');
        var str = '' + this;
        count = +count;
        if (count != count)
            count = 0;
        if (count < 0)
            throw new RangeError('repeat count must be non-negative');
        if (count == Infinity)
            throw new RangeError('repeat count must be less than infinity');
        count = Math.floor(count);
        if (str.length == 0 || count == 0)
            return '';
        if (str.length * count >= 1 << 28)
            throw new RangeError('repeat count must not overflow maximum string size');
        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while (count) {
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    };
}
if (typeof String.prototype.padStart !== 'function') {
    String.prototype.padStart = function padStart(maxLength, fillString) {
        maxLength = maxLength >> 0;
        fillString = String((typeof fillString !== 'undefined' ? fillString : ' '));
        if (this.length > maxLength) {
            return String(this);
        }
        else {
            maxLength = maxLength - this.length;
            if (maxLength > fillString.length) {
                fillString += fillString.repeat(maxLength / fillString.length);
            }
            return fillString.slice(0, maxLength) + String(this);
        }
    };
}
if (typeof Array.prototype.fill !== 'function') {
    Array.prototype.fill = function fill(value) {
        if (this == null) {
            throw new TypeError('this is null or not defined');
        }
        var O = Object(this);
        var len = O.length >>> 0;
        var start = arguments[1];
        var relativeStart = start >> 0;
        var k = relativeStart < 0 ?
            Math.max(len + relativeStart, 0) :
            Math.min(relativeStart, len);
        var end = arguments[2];
        var relativeEnd = end === undefined ?
            len : end >> 0;
        var final = relativeEnd < 0 ?
            Math.max(len + relativeEnd, 0) :
            Math.min(relativeEnd, len);
        while (k < final) {
            O[k] = value;
            k++;
        }
        return O;
    };
}
if (typeof Element !== 'undefined' && typeof Element.prototype.remove !== 'function') {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}
if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var thisArg = arguments[1];
        var k = 0;
        while (k < len) {
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
                return k;
            }
            k++;
        }
        return -1;
    };
}
if (!Array.prototype.includes) {
    Array.prototype.includes = function (valueToFind, fromIndex) {
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;
        if (len === 0) {
            return false;
        }
        var n = fromIndex | 0;
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
        function sameValueZero(x, y) {
            return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
        }
        while (k < len) {
            if (sameValueZero(o[k], valueToFind)) {
                return true;
            }
            k++;
        }
        return false;
    };
}
